export default __webpack_public_path__ + "static/media/ki_logo_02_beyaz.1b24a738.png";